import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfettiExplosion from 'react-confetti-explosion';
import React, { useState, useEffect } from 'react';

const ChatBox = ({ children, timer_value=0,className='', ...props }) => {
    const [showLoader, setShowLoader] = useState(true);
    const [flyIn, setFlyIn] = useState(false);
    const [time, setTime] = useState(0);

    const [isExploding, setIsExploding] = React.useState(true);
    const getCurrentTime = () => {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, "0");
        const minutes = now.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
      };
      
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoader(false);
            setFlyIn(true);
            const new_timer = setTimeout(() => {
                setFlyIn(false);
            }, 2000);
            setTime(getCurrentTime());
        }, timer_value);

        return () => {
            clearTimeout(timer);
            console.log("BLUB FLY IasdN")
        }
    }, []);

    const combinedClassName = `bubble left ${className} ${flyIn ? 'fly-in' : ''}`;

    return (
        <>
            {showLoader && <div className="loader"></div>}
            <div className={combinedClassName}  style={{ opacity: showLoader ? '0' : '1' }} {...props} >
                <p className="chat-text">{children}</p>
                <p className='text-time'>{time}<FontAwesomeIcon
                style={{color:"#37acc6", marginLeft: "5px"}}
                icon={faCheckDouble}
              /></p>
            </div>
        </>
    );
};


export default ChatBox;